import { render, staticRenderFns } from "./BsMaUploadExcel.vue?vue&type=template&id=ae648580&scoped=true"
import script from "./BsMaUploadExcel.vue?vue&type=script&lang=js"
export * from "./BsMaUploadExcel.vue?vue&type=script&lang=js"
import style0 from "./BsMaUploadExcel.vue?vue&type=style&index=0&id=ae648580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae648580",
  null
  
)

export default component.exports